<template>
  <div class="flex items-stretch h-full">
    <div class="hidden md:flex w-2/4 bg-primary dark:bg-primary-900 text-xs relative">
      <img class="object-cover mix-blend-soft-light filter grayscale" src="@/assets/img/grupo-login.png" alt="aside" />
      <div class="absolute bottom-4 left-0 w-full z-10 text-white hidden">
        <div class="p-8">
          <h2 class="text-4xl font-bold mb-2">One Ring to rule them all</h2>
          <h3 class="text-xl font-medium opacity-80">One Ring to find them, One Ring to bring them all, and in the darkness bind them</h3>
        </div>
        <p class="text-center border-t border-solid border-white border-opacity-20 pt-4">
          Photo by <a href="#" class="">Jesper Aggergaard</a> on
          <a href="#" class="">Unsplash</a>
        </p>
      </div>
    </div>
    <div class="w-full flex flex-col min-h-full">
      <div class="main flex-grow">
        <div class="w-full flex flex-col min-h-full dark:bg-darkblue-900">
          <div class="flex flex-grow items-center justify-center">
            <div class="w-full max-w-sm relative">
              <base-logo alt="Real Grupo Cultural Covadonga, control de accesos" class="mx-auto mb-6 brand" />
              <div class="text-center">
                <h2 class="font-bold leading-tight">Bienvenida/o al portal de control de accesos</h2>
                <p class="text-sm leading-tight mt-1">Desde aquí podrá configurar todas las funcionalidades relacionadas con el acceso a las instalaciones.</p>
              </div>
              <form class="px-4 mt-4 sm:px-0">
                <base-button class="w-full" mode="primary" text="Acceder" @click="login" :loading="logging" :disabled="logging" />
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-shrink-0 p-4 flex items-center justify-center dark:bg-darkblue-900">
        <copy-legal />
      </div>
    </div>
  </div>
</template>

<script>
import CopyLegal from '@/components/CopyLegal.vue'
import { authClientInstance } from '@/auth/AuthClient'

export default {
  name: 'PublicLogin',
  components: {
    CopyLegal
  },
  data: function () {
    return {
      logging: false
    }
  },
  methods: {
    login: async function () {
      try {
        this.logging = true
        await authClientInstance.login()
        this.$store.commit('auth/removeUser')
        this.$store.commit('images/removeImages')
        this.$router.push({ name: process.env.VUE_APP_REDIRECT_LOGGED_IN }).catch(() => console.info('No socio'))
      } catch (error) {
        if (error.message !== 'Popup closed by user') {
          this.doFeedback()
        }
      } finally {
        this.logging = false
      }
    }
  }
}
</script>
